<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="actiontypeSelectItems"
            v-model="item.type"
            :items="actiontypeSelectItems"
            :error-messages="typeErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('ticket.actiontype')"
            item-text="name"
            item-value="@id"
            chips
          >

          <template v-slot:selection="{ attrs, item}">
            <v-chip class="ma-2" label text-color="white"  >
              <v-icon left v-if="item.public">mdi-eye</v-icon>
              <v-icon left v-else>mdi-eye-off</v-icon>
              {{ item.name }}
            </v-chip>
          </template>
          <template v-slot:item="{ index, item }">
            <v-chip class="ma-2" label text-color="white"  >
              <v-icon left v-if="item.public">mdi-eye</v-icon>
              <v-icon left v-else>mdi-eye-off</v-icon>
              {{ item.name }}
            </v-chip>

          </template>
        </v-combobox>
        </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="6" >
            <v-file-input
            v-model="item.file"
            :error-messages="fileErrors"
            :label="$t('global.fileinput')"
            show-size
            required
            @input="$v.item.file.$touch()"
            @blur="$v.item.file.$touch()"

            ></v-file-input>
          </v-col>
        </v-row>
        <v-row>
        <v-col cols="12" sm="12" md="12">
          <strong class="" >{{ $t('ticket.content') }}:</strong>
          <quill-editor 
            v-model="item.content" 
            class="editorQuill" 
            :options="editorOptions" 
            @input="$v.item.content.$touch()">
          </quill-editor>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { maxsizefile } from '../../utils/files';
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.snow.css'


export default {
  name: 'TicketactionForm',
  mixins: [validationMixin],
  components: {
    quillEditor,
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.actiontypeGetSelectItems();

  },
  data() {
    return {
        content: null,
        type: null,
        file: null,
        editorOptions: { 
          theme: 'snow', // Thème de l'éditeur
          placeholder: 'Insérer une description',
          modules: {       
            toolbar: 
            [             
              ['bold', 'italic','underline'],
              ['blockquote','code-block'], // Options de style de texte    
              [{ 'list': 'bullet' },{ 'list': 'ordered' }]
            ]}}
    };
  },
  computed: {
    isLoading() {
      return (this.isLoading_actiontype
       );
    },
    ...mapFields('actiontype', {
      actiontypeSelectItems: 'selectItems',
      isLoading_actiontype : 'isLoading'
    }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    contentErrors() {
      const errors = [];

      if (!this.$v.item.content.$dirty) return errors;

      has(this.violations, 'content') && errors.push(this.violations.content);

      !this.$v.item.content.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    typeErrors() {
      const errors = [];

      if (!this.$v.item.type.$dirty) return errors;

      has(this.violations, 'type') && errors.push(this.violations.type);


      return errors;
    },
    fileErrors() {
      const errors = [];

      if (!this.$v.item.file.$dirty) return errors;

      has(this.violations, 'file') && errors.push(this.violations.file);

      !this.$v.item.file.maxsizefile && errors.push(this.$t('global.maxsize'));
      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
    ...mapActions({
      actiontypeGetSelectItems: 'actiontype/fetchSelectItems'
    }),
  },
  validations: {
    item: {
      content: {
        required,
      },
      file: {
        maxsizefile : maxsizefile(20),
      },
      type: {
        required,
      },
    }
  },
  watch: {
   
  }
};
</script>
<style>
.ql-toolbar .ql-stroke {
    fill: none;
    stroke: #fff;
}
.ql-editor::before {
  color: white !important;
  opacity: 0.33;
}
</style>